import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextAreaBox, TextBox } from '@guryou/html-components';

const LocationUrl = ({ locationObject, fullWidth, disabled }) => {
  const { t } = useTranslation();

  return (
    <>
      <TextBox
        disabled={disabled}
        fullWidth={fullWidth}
        xs={fullWidth && 12}
        label="URL"
        name="url"
        value={locationObject.url || locationObject.locationNote || locationObject.note || ''}
      />
      <TextAreaBox
        disabled={disabled}
        fullWidth={fullWidth}
        xs={fullWidth && 12}
        label={t('GENERAL.leaveNote')}
        placeholder={t('GENERAL.enterValidUrl')}
        name="locationNote"
        value={locationObject.locationNote || locationObject.note || ''}
      />
    </>
  );
};

export default LocationUrl;
